import React from 'react';
import { motion } from 'framer-motion';
const aspirations = ['¿Cómo sería tu vida si ejecutar fuera automático?', '¿Qué pasaría si dejaras de negociar con tu debilidad?', '¿Cuánto crecería tu negocio si tu mente obedeciera?', '¿Quién serías si tu palabra valiera más que tus excusas?', '¿Estás listo para convertir disciplina en identidad?'];
export function AspirationSection() {
  return <section className="py-24 bg-[#111] relative overflow-hidden" data-id="element-1">
      {/* Subtle gold accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A84C]/5 rounded-full blur-[100px]" data-id="element-2" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-3">
        <div className="mb-16 text-center" data-id="element-4">
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white mb-4" data-id="element-5">
            IMAGINÁ ESTO
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C] mx-auto" data-id="element-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-7">
          {aspirations.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`p-8 border border-white/10 hover:border-[#C9A84C]/50 transition-all duration-300 bg-[#0a0a0a] ${i === aspirations.length - 1 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2 bg-[#C9A84C]/10 border-[#C9A84C]/30' : ''}`} data-id="element-8">
              <p className={`text-xl font-medium ${i === aspirations.length - 1 ? 'text-[#C9A84C]' : 'text-gray-300'}`} data-id="element-9">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}